export default "__VITE_ASSET__BgT$hONP__"